import {
    USER_LOGIN_REQUEST,
    USER_LOGIN_SUCCESS,
    USER_LOGIN_FAIL,

    USER_LOGOUT,

    USER_REGISTER_REQUEST,
    USER_REGISTER_SUCCESS,
    USER_REGISTER_FAIL,
    USER_CONTEXT_FAIL,
    USER_CONTEXT_SUCCESS,
    USER_CONTEXT_REQUEST
  } from "../constants/userConstants";


export const userLoginReducer = (state = {}, action) => {
    switch (action.type) {
      case USER_LOGIN_REQUEST:
        return { ...state, loading: true };
      case USER_LOGIN_SUCCESS:
        return { loading: false, userInfo: action.payload };
      case USER_LOGIN_FAIL:
        return { loading: false, error: action.payload };
      default:
        return state;
    }
  };

  export const userRegisterReducer = (state = {}, action) => {
    switch (action.type) {
      case USER_REGISTER_REQUEST:
        return { loading: true };
      case USER_REGISTER_SUCCESS:
        return { loading: false, userInfo: action.payload, success: true };
      case USER_REGISTER_FAIL:
        return { loading: false, error: action.payload };
      case USER_LOGOUT:
        return {};
      default:
        return state;
    }
  };

  export const userContextReducer = (state = {}, action) => {
    switch (action.type) {
      case USER_CONTEXT_REQUEST:
        return { loading: true };
      case USER_CONTEXT_SUCCESS:
        return { loading: false, userInfo: action.payload, success: true };
      case USER_CONTEXT_FAIL:
        return { loading: false, error: action.payload };
      default:
        return state;
    }
  };